import styled from '@emotion/styled';
import { black } from 'Styles/colors';

export const InformationText = styled.p`
  color: ${black._74};
  font-style: italic;
  text-align: center;
`;
